import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiKey } from '../../entities/apiKey/apiKey';
import { ApiKeysService } from '../../services/apiKeys/apiKeys.service';
import { LoadingService } from '../../services/loading.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';

@Component({
  selector: 'app-apikey-dialog',
  templateUrl: './apikey-dialog.component.html',
  styleUrls: ['./apikey-dialog.component.scss']
})
export class ApiKeyDialogComponent
  implements EditDialogInstance {

  apiKeyForm: FormGroup;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public apiKeyService: ApiKeysService,
    public loadingService: LoadingService
  ) {
    this.apiKeyForm = new FormGroup({});

    // add form controls
    this.apiKeyForm.addControl('comment', new FormControl());
  }


  onConfirm(editDialogComponent: EditDialogComponent<any>): void {

    this.loadingService.setLoading(true);
      // its a create
    let apiKeyInput = new ApiKey(this.apiKeyForm.value);
    this.apiKeyForm.disable();
    this.apiKeyService.createApiKey( apiKeyInput, (result: any) => {
        this.ref.close(result.data);
    });
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.apiKeyForm;
  }

}
